import { createRouter, createWebHistory } from "vue-router";


//imports de vistas de App 
import HomeView from '../components/Home.vue';
import LoginHome from "@/components/LoginHome.vue";
import ExpressMV from '../components/ExpressMV.vue';
import appbarView from '../components/appbar/appbarView.vue';
import PagarView from "@/components/PagarView.vue";
import RegistroView from '../components/RegistroView.vue';
import MarcasXProductoView from '../components/MarcasXProductoView.vue';
import FacturacionForm from '../components/menu_usuario/FacturacionView.vue';
import perfil from '../components/menu_usuario/DatosUsuarioview.vue';
import Promociones from '../components/PromoView.vue';
import TopDiezView from "@/components/TopDiezView.vue";
import HistorialPedidosView from "@/components/HistorialPedidosView.vue";
import penafielView from "@/components/marcas/penafielView.vue";
import ElectrolitView from "@/components/marcas/ElectrolitView.vue";
import redbullView from "@/components/marcas/redbullView.vue";
import CaribeCoolerView from "@/components/marcas/CaribeCoolerView.vue";
import JackDanielsView from "@/components/marcas/JackDanielsView.vue";
import NewMixView from "@/components/marcas/NewMixView.vue";
import BoonesView from "@/components/marcas/BoonesView.vue";
import ClamatoView from "@/components/marcas/clamatoView.vue";
import peñafiel_adasView from "@/components/marcas/peñafiel_adasView.vue";
import VualaVistaView from "@/components/marcas/VualaVistaView.vue";
import SucessView from "@/components/SucessView.vue";
import HelloWorld from "@/components/HelloWorld.vue";
import UserInfoView from "@/components/appbar/UserInfoView.vue";
import AjustesView from "@/components/menu_usuario/AjustesView.vue";
import AguaView from "@/components/categorias/AguaView.vue";
import EnergetizantesView from "@/components/categorias/EnergetizantesView.vue";
import AntojitosView from "@/components/categorias/AntojitosView.vue";
import DescargarExcel from "@/components/Administrador/DescargarExcel.vue";
import CarritoViewStore from "@/components/Administrador/CarritoViewStore.vue";
import SupremaView from "@/components/marcas/SupremaView.vue";
import AllenView from "@/components/marcas/AllenView.vue";
import DashboardView from "@/components/Administrador/DashboardView.vue";
import VistaStock from "@/components/Administrador/VistaStock.vue";
import BuscadorPedidos from "@/components/Administrador/BuscadorPedidos.vue";
import BebidasPrepradasView from "@/components/categorias/BebidasPrepradasView.vue";
import ImportadorExistenciaView from "@/components/Administrador/ImportadorExistenciaView.vue";
import AvisoVue from "@/components/Administrador/AvisoVue.vue";
import NissinView from "@/components/marcas/NissinView.vue";
import { useUserStore } from "@/stores/userStore";
import BoostrapView from "@/components/BoostrapView.vue";
const routes = [
  {
    path: '/',
    name: 'BootstrapView',
    component: BoostrapView,

  },

  {
    path: '/home',
    name: 'HomeView',
    component: HomeView,
    meta: { requiresAuth: true, title: 'Inicio' }
  },

  {
    path: '/login',
    name: 'LoginHome',
    meta: { title: 'GRUPOMV' },
    component: LoginHome,
  },

  {
    path: '/ExpressMV',
    name: 'ExpressMV',
    component: ExpressMV,
    meta: { requiresAuth: true }
  },


  {
    path: '/appbarView',
    name: 'appbarView',
    component: appbarView,
  },

  {
    path: '/user-info',
    name: 'userinfo',
    component: UserInfoView,
    meta: { requiresAuth: true, title: 'Mi perfil' }


  },

  {
    path: '/metodo-pago',
    name: 'metodo',
    component: PagarView,
    meta: { requiresAuth: true }


  },
  {
    path: '/registro',
    name: 'registro',
    component: RegistroView,


  },

  {
    path: '/marcas-mvgrupo',
    name: 'marcas-peñafiel',
    component: MarcasXProductoView,
    meta: { requiresAuth: true }

  },

  {
    path: '/datos-facturacion',
    name: 'facturacion-form',
    component: FacturacionForm,
    meta: { requiresAuth: true }


  },

  {
    path: '/perfil',
    name: 'perfil',
    component: perfil,
    meta: { requiresAuth: true }
  },
  {
    path: '/promo',
    name: 'promo-vista',
    component: Promociones,
    meta: { requiresAuth: true }
  },

  {

    path: '/top-10',
    name: 'top-diez',
    component: TopDiezView,
    meta: { requiresAuth: true, title: 'Top 10' }

  },
  {
    path: '/pedidos',
    name: 'historial',
    component: HistorialPedidosView,
    meta: { requiresAuth: true }
  },
  {
    path: '/101List',
    name: '101List',
    component: penafielView,
    meta: { requiresAuth: true }
  },
  {
    path: '/101-ElectrolitView',
    name: '101-ElectrolitView',
    component: ElectrolitView,
    meta: { requiresAuth: true }

  },
  {
    path: '/103-redbull',
    name: '103-rb',
    component: redbullView,
    meta: { requiresAuth: true }

  },
  {
    path: '/101-CaribeCoolerView',
    name: '101-CaribeCoolerView',
    component: CaribeCoolerView,
    meta: { requiresAuth: true }

  },

  {
    path: '/101-JackDanielsView',
    name: '101-JackDanielsView',
    component: JackDanielsView,
    meta: { requiresAuth: true }

  },

  {
    path: '/101-NewMix',
    name: '101-newxmix',
    component: NewMixView,
    meta: { requiresAuth: true }


  },
  {
    path: '/101-ClamatoView',
    name: 'ClamatoView',
    component: ClamatoView,
    meta: { requiresAuth: true }

  },
  {

    path: '/101-BoonesView',
    name: '101-BoonesView',
    component: BoonesView,
    meta: { requiresAuth: true }

  },

  {
    path: '/101-adas',
    name: '101-adas',
    component: peñafiel_adasView,
    meta: { requiresAuth: true }

  },
  {
    path: '/101-vuala',
    name: '101-vuala',
    component: VualaVistaView,
    meta: { requiresAuth: true }
  },

  {
    path: '/SucessView',
    name: 'SucessView',
    component: SucessView,
    meta: { requiresAuth: true }

  },

  {
    path: '/Mapa',
    name: 'mapaview',
    component: HelloWorld,
    meta: { requiresAuth: true }
  },

  {
    path: '/ajuste',
    name: 'AjustesView',
    component: AjustesView,
    meta: { requiresAuth: true }
  },

  {
    path: '/100-aguafiel',
    name: 'AguaFielView',
    component: AguaView,
    meta: { requiresAuth: true }
  },


  {
    path: '/100-EnergetizantesView',
    name: 'EnergetizantesView',
    component: EnergetizantesView,
    meta: { requiresAuth: true }
  },

  {

    path: '/100-vualaView',
    name: 'VualaView',
    component: AntojitosView,
    meta: { requiresAuth: true }

  },

  {

    path: '/Excel-export',
    name: 'ExportExcelView',
    component: DescargarExcel,
    meta: { requiresAuth: true }

  },

  {

    path: '/carrito-vue',
    name: 'carrito-vue',
    component: CarritoViewStore,
    meta: { requiresAuth: false }

  },
  {

    path: '/allen-limpieza',
    name: 'allen-limpieza',
    component: AllenView,
    meta: { requiresAuth: false }

  },


  {
    path: '/139-suprema',
    name: '139-suprema',
    component: SupremaView,
    meta: { requiresAuth: true }
  },

  {

    path: '/dashboard-admin',
    name: 'dashboard-admin',
    component: DashboardView,
    meta: { requiresAuth: true }

  },
  {

    path: '/Vista-stock',
    name: 'Vista-stock',
    component: VistaStock,
    meta: { requiresAuth: true }
  },

  {

    path: '/buscador-pedidos',
    name: 'buscador-pedidos',
    component: BuscadorPedidos,
    meta: { requiresAuth: true }


  },
  {

    path: '/bebidas-alcho',
    name: 'bebidas-alcho',
    component: BebidasPrepradasView,
    meta: { requiresAuth: true }

  },


  {

    path: '/exce-stock-importador',
    name: 'exce-stock-importador',
    component: ImportadorExistenciaView,
    meta: { requiresAuth: true }


  },


  {

    path: '/aviso-privacidad',
    name: 'aviso-privacidad',
    component: AvisoVue,
    meta: { requiresAuth: false }

  },
  {

    path: '/141-nissin',
    name: '141-nissin',
    component: NissinView,
    meta: { requiresAuth: false }

  }

]
const router = createRouter({
  history: createWebHistory(),
  routes,

});

router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore();

  console.log("🧭 ENTRANDO A:", to.path);
  console.log("🔐 Antes initSession isAuthenticated:", userStore.isAuthenticated);

  // 🛑 Evitar bucle en Logout: Si vamos a /login y NO es carga inicial, no forzamos sesión
  const isInitialLoad = from.matched.length === 0;

  if (!userStore.isSessionReady && (to.path !== '/login' || isInitialLoad)) {
    try {
      await userStore.initSession();
    } catch (error) {
      console.error("⚠️ Error inicializando sesión en router:", error);
    }
  }

  console.log("🔐 Después initSession isAuthenticated:", userStore.isAuthenticated);

  // 🛑 Si ya está logueado y va al login, mandar al home
  if (to.path === '/login' && userStore.isAuthenticated) {
    return next('/home');
  }

  // Definir rutas públicas que no requieren autenticación
  const publicRoutes = ['/login', '/registro', '/aviso-privacidad', '/'];
  const requiresAuth = !publicRoutes.includes(to.path);

  if (requiresAuth && !userStore.isAuthenticated) {
    console.warn("🚫 REDIRECT A LOGIN: Ruta restringida y usuario no autenticado");
    return next("/login");
  }

  if (to.meta.requiresAuth && !userStore.isAuthenticated) {
    console.warn("🚫 REDIRECT A LOGIN");
    return next("/login");
  }

  next();
});

export default router;